import React from "react";
import oliveIbeto from "../../assets/staff/BIOMEDICAL ENGINEERING/olive_ibeto.jpg";
import abrahamSunday from "../../assets/staff/BIOMEDICAL ENGINEERING/abraham_sunday.jpg";
import anneFalola from "../../assets/staff/BIOMEDICAL ENGINEERING/anne_falola.jpg";
import fakeyeElijah from "../../assets/staff/BIOMEDICAL ENGINEERING/fakeye_elijah.jpg";
import adegokeSegun from "../../assets/staff/BIOMEDICAL ENGINEERING/adegoke_segun.jpg";
import olatundeSunday from "../../assets/staff/BIOMEDICAL ENGINEERING/olatunde_sunday.jpg";
import mustaphaLawal from "../../assets/staff/BIOMEDICAL ENGINEERING/mustapha_lawal.jpg";
import oluwasegunEbenezer from "../../assets/staff/BIOMEDICAL ENGINEERING/oluwasegun_ebenezer.jpg";
import oluwaseunMoriam from "../../assets/staff/BIOMEDICAL ENGINEERING/oluwaseun_moriam.jpeg";
import alaoOlamide from "../../assets/staff/BIOMEDICAL ENGINEERING/alao_olamide.jpg";
import adekeyeOlufemi from "../../assets/staff/BIOMEDICAL ENGINEERING/adekeye_olufemi.jpg";
import kayodeSunday from "../../assets/staff/BIOMEDICAL ENGINEERING/kayode_sunday.jpg";
import adewunmiOlayemi from "../../assets/staff/BIOMEDICAL ENGINEERING/adewunmi_olayemi.jpeg";
import olorunsogoBabatope from "../../assets/staff/BIOMEDICAL ENGINEERING/olorunsogo_babatope.jpg";

const BiomedicalEngineeringStaff = [
  {
    name: "Kayode Sunday Akin",
    qualification:
      " HND Electrical & Electronics Engineering 1998, PGD- 2009, Bmet-2011,B.Tech -2025 Biomedical Engineering Technology",
    designation: "Head, FSBME",
    photo: kayodeSunday,
  },
  {
    name: "Ibeto, Olive Ogochukwu ",
    qualification:
      "BTech Biomedical Technology 2019 MSc. Biomedical Engineering 2023",
    designation: "Senior Engineer (Biomedical) (Lecturer)",
    photo: oliveIbeto,
  },
  {
    name: "Abraham, Olalekan Sunday",
    qualification: "ND Biomedical Technology",
    designation: "Chief Health Assistant (Biomedical)",
    photo: abrahamSunday,
  },
  {
    name: "Engr. Bello, Anne Oyindamola ",
    qualification:
      "BSc Electrical & Electronics Engineering, 2012 MSc Biomedical Engineering, 2015",
    designation: "Senior Engineer (Biomedical) (Lecturer) (Reg.COREN)",
    photo: anneFalola,
  },
  {
    name: "Fakeye, Elijah Oluwatomi",
    qualification:
      "BEng.(2013), MEng. (2020) Electrical & Electronics Engineering",
    designation: "Chief Technical Officer  ",
    photo: fakeyeElijah,
  },
  {
    name: "Adegoke, Segun Japhet",
    qualification:
      "HND, Electrical Engineering, MSc Biomedical Engineering in view",
    designation: "Chief Health Assistant (Biomedical)",
    photo: adegokeSegun,
  },
  {
    name: "Olawuyi, Olatunde Sunday",
    qualification:
      "BSc, Chemical Engineering 2007, PGD, Biomedical Engineering 2018 MSc, Biomedical Engineering, in view",
    designation: "Biomedical Engineer I (Lecturer) ",
    photo: olatundeSunday,
  },
  {
    name: "Engr. Lawal, Mustapha Ayinde ",
    qualification: "ND 2001, B. Eng. 2006, PGDE 2014 Mechanical Engineering",
    designation: "Senior Engineer (Mechanical ) (Lecturer) (Reg.COREN)",
    photo: mustaphaLawal,
  },
  {
    name: "Ereola, Oluwasegun Ebenezer",
    qualification: "HND Electrical & Electronics Engineering",
    designation: "Higher Technical Officer ",
    photo: oluwasegunEbenezer,
  },
  {
    name: "Oluwaseun Moriam Oduyebo",
    qualification: "BSc Business Administration In View ",
    designation: "Clerical Officer I",
    photo: oluwaseunMoriam,
  },
  {
    name: "Alao Olamide Raphael ",
    qualification: "ND 2022 Biomedical Engineering Technology",
    designation: "Technical Officer (Biomedical) ",
    photo: alaoOlamide,
  },
  {
    name: "Adekeye olufemi James",
    qualification:
      "HND 2008. B Eng/2025 in view Electrical & Electronics Engineering ",
    designation: "Senior Technical Officer (Biomedical)",
    photo: adekeyeOlufemi,
  },
  {
    name: "Apelehin Adewunmi Olayemi",
    qualification:
      "ND, Statistics 2012, ND, Accounting 2013, Bsc, Accounting in view",
    designation: "Chief Data Processing Officer",
    photo: adewunmiOlayemi,
  },
  {
    name: "Olorunsogo Babatope",
    qualification: "HND Electrical & Electronics Engineering",
    designation: "Technical officer",
    photo: olorunsogoBabatope,
  },
];

export default BiomedicalEngineeringStaff;
